export default class GA4EventApi {
  // 测试GTM-WXXMW4JJ
  // 上捷测试GTM-WJN2WD3Z
  constructor(gtm_id = "", ga_id = "", ads = "") {
    // 暂时没有用到
    this.ga_id = ga_id;
    this.ads = ads;

    this.gtm_id = gtm_id || "GTM-WJN2WD3Z";
  }

  // 后面根据情况来确定是否使用
  injectGtag() {
    let script1 = document.createElement("script");
    script1.async = true;
    script1.src = `https://www.googletagmanager.com/gtag/js?id=${this.ga_id}`;
    document.head.appendChild(script1);

    let script2 = document.createElement("script");
    script2.innerHTML = `
          window.dataLayer = window.dataLayer || [];
          function gtag() { dataLayer.push(arguments); }
          gtag('js', new Date());
          gtag('config', '${this.ga_id}');
          gtag('config', '${this.ads?.id}');
          gtag('event', 'conversion', {'send_to': '${this.ads?.browse}'});
    `;

    document.head.appendChild(script2);
  }

  injectGtm() {
    let script2 = document.createElement("script");
    script2.innerHTML = `
    (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','${this.gtm_id}');
    `;

    document.head.appendChild(script2);

    const noscript = document.createElement("noscript");
    const iframe = document.createElement("iframe");

    iframe.src = `https://www.googletagmanager.com/ns.html?id=${this.gtm_id}`;
    iframe.height = "0";
    iframe.width = "0";
    iframe.style.display = "none";
    iframe.style.visibility = "hidden";

    noscript.appendChild(iframe);

    // It's best to append the noscript tag to the body, as early as possible.
    document.body.insertBefore(noscript, document.body.firstChild);
  }

  // 参数：商品详情
  view_item(commodity) {
    // 检查commodity对象及其属性items是否存在和非空
    if (
      !commodity ||
      !commodity.items ||
      !Array.isArray(commodity.items) ||
      commodity.items.length === 0
    ) {
      console.error("commodity data is missing or items are empty");
      return; // 如果不存在，打印错误信息并退出函数
    }

    // 初始化items数组
    let items = commodity.items.map((e, index) => {
      // 对每个条目进行映射，创建新的对象，并确保所有数据都是存在的且格式正确
      // 可以在这里添加更多的字段检查和默认值设置
      return {
        item_name: e.form_name || "Unknown", // 如果e.form_name不存在，使用'Unknown'
        item_id: e.itemid || "", // 如果e.itemid不存在，使用空字符串
        price: String(e.price).replace(/[^0-9.]/g, ""), // 确保价格只包含数字和点
        item_list_name: commodity.group_name || "Default Group", // 如果commodity.group_name不存在，使用'Default Group'
        item_list_id: commodity.oig_id || "", // 如果commodity.oig_id不存在，使用空字符串
        index: e.orderby_display || index, // 如果e.orderby_display不存在，使用数组的索引
        quantity: 1, // 这里假设每个商品的数量是1，根据需要可以调整
      };
    });

    // 清除之前的电子商务对象，并推送新的事件
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "view_item",
      ecommerce: {
        currency: "TWD",
        items: items,
      },
    });
  }
  // 参数：商品详情、商品项id、商品项数量
  add_to_cart(commodity, item_id, item_num) {
    // 检查商品数据是否有效
    if (!commodity || !Array.isArray(commodity.items)) {
      console.error("Invalid commodity data provided.");
      return;
    }

    // 查找匹配的商品项
    let item = commodity.items.find((e) => e.itemid == item_id);
    if (!item) {
      console.error("Item not found in commodity data.");
      return;
    }

    // 检查数量是否有效
    if (!Number.isInteger(item_num) || item_num < 1) {
      console.error("Invalid item quantity provided.");
      return;
    }

    // 构造购物车商品对象
    let items = [
      {
        item_name: item.form_name || "Unknown Item", // 如果商品名称不存在，使用'Unknown Item'
        item_id: item.itemid,
        price: String(item.price).replace(/[^0-9.]/g, ""),
        item_list_name: commodity.group_name || "Default Group",
        item_list_id: commodity.oig_id || "Default ID",
        index: item.orderby_display || 0,
        quantity: item_num,
      },
    ];

    // 计算商品总价
    let value = parseFloat(items[0].price) * item_num;
    if (isNaN(value)) {
      console.error("Price calculation error.");
      return;
    }

    // 推送到dataLayer
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null }); // 清除之前的电子商务对象
    dataLayer.push({
      event: "add_to_cart",
      ecommerce: {
        currency: "TWD",
        value: value.toFixed(2), // 保留两位小数
        items: items,
      },
    });
  }
  // 参数：购物车
  view_cart(cart) {
    let items = [];
    // 验证购物车数据
    if (!cart || !Array.isArray(cart.item)) {
      console.error("Invalid cart data.");
      return;
    }

    // 构建商品列表
    cart.item.forEach((e) => {
      if (!e.item_id || !e.form_name) {
        console.error("Missing item ID or name.");
        return;
      }
      // 验证数量和价格是否为有效数字
      let quantity = parseInt(e.num, 10);
      let price = parseFloat(e.price.replace(/[^0-9.]/g, ""));
      if (isNaN(quantity) || isNaN(price)) {
        console.error("Invalid quantity or price.");
        return;
      }
      // 添加到商品列表
      items.push({
        item_name: e.form_name,
        item_id: e.item_id,
        price: price.toFixed(2), // 格式化价格为两位小数
        index: parseInt(e.orderby_display, 10),
        quantity: quantity,
      });
    });

    // 如果商品列表为空，则不继续执行
    if (items.length === 0) {
      console.error("No valid items to add to cart.");
      return;
    }

    // 计算购物车总价
    let value = parseFloat(cart.total.replace(/[^0-9.]/g, ""));
    if (isNaN(value)) {
      console.error("Invalid total value.");
      return;
    }

    // 推送购物车数据到dataLayer
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null }); // 清除之前的电子商务对象
    dataLayer.push({
      event: "view_cart",
      ecommerce: {
        currency: "TWD",
        value: value.toFixed(2), // 格式化总价为两位小数
        items: items,
      },
    });
  }
  // 参数：购物车
  begin_checkout(cart) {
    // 验证购物车对象和项目列表的存在
    if (!cart || !Array.isArray(cart.item) || cart.item.length === 0) {
      console.error("Invalid cart data or cart items are empty.");
      return;
    }

    let items = [];
    let totalValue = 0;

    // 构建商品列表并计算总价
    cart.item.forEach((e, index) => {
      // 验证关键字段是否存在
      if (
        !e.form_name ||
        !e.item_id ||
        isNaN(parseFloat(e.price)) ||
        isNaN(parseInt(e.num))
      ) {
        console.warn(`Invalid data for item at index ${index}. Skipping item.`);
        return;
      }

      // 格式化价格和数量
      let price = parseFloat(e.price.replace(/[^0-9.]/g, "")).toFixed(2);
      let quantity = parseInt(e.num, 10);

      // 添加商品到列表并累加到总价
      items.push({
        item_name: e.form_name,
        item_id: e.item_id,
        price: price,
        index: parseInt(e.orderby_display, 10),
        quantity: quantity,
      });

      totalValue += price * quantity;
    });

    // 如果没有有效的商品，不继续执行
    if (items.length === 0) {
      console.error("No valid items for checkout.");
      return;
    }

    // 格式化总价
    let formattedTotal = parseFloat(cart.total.replace(/[^0-9.]/g, "")).toFixed(
      2
    );
    if (isNaN(formattedTotal)) {
      console.error("Cart total value is invalid.");
      return;
    }

    // 确保计算出的总价与购物车提供的总价相符
    if (formattedTotal !== totalValue.toFixed(2)) {
      console.warn("Computed total value does not match cart's total value.");
    }

    // 推送到dataLayer
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null }); // 清空之前的电子商务对象
    dataLayer.push({
      event: "begin_checkout",
      ecommerce: {
        currency: "TWD",
        value: formattedTotal,
        items: items,
      },
    });
  }
  // 参数：购物车、支付方式
  add_payment_info(cart, payment) {
    // 验证购物车对象和项目列表的存在
    if (!cart || !Array.isArray(cart.item) || cart.item.length === 0) {
      console.error("Invalid cart data or cart items are empty.");
      return;
    }

    // 验证支付方式
    if (typeof payment !== "string" || payment.trim() === "") {
      console.error("Invalid or empty payment type.");
      return;
    }

    let items = [];
    let totalValue = 0;

    // 构建商品列表并计算总价
    cart.item.forEach((e) => {
      // 验证关键字段是否存在
      if (
        !e.form_name ||
        !e.item_id ||
        isNaN(parseFloat(e.price)) ||
        isNaN(parseInt(e.num))
      ) {
        console.warn(
          `Invalid data for item with ID ${e.item_id}. Skipping item.`
        );
        return;
      }

      // 格式化价格和数量
      let price = parseFloat(e.price.replace(/[^0-9.]/g, "")).toFixed(2);
      let quantity = parseInt(e.num, 10);

      // 添加商品到列表并累加到总价
      items.push({
        item_name: e.form_name,
        item_id: e.item_id,
        price: price,
        index: parseInt(e.orderby_display, 10),
        quantity: quantity,
      });

      totalValue += price * quantity;
    });

    // 如果没有有效的商品，不继续执行
    if (items.length === 0) {
      console.error("No valid items to add payment info.");
      return;
    }

    // 格式化购物车的总价
    let formattedTotal = parseFloat(cart.total.replace(/[^0-9.]/g, "")).toFixed(
      2
    );
    if (isNaN(formattedTotal)) {
      console.error("Cart total value is invalid.");
      return;
    }

    // 推送到dataLayer
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null }); // 清空之前的电子商务对象
    dataLayer.push({
      event: "add_payment_info",
      ecommerce: {
        currency: "TWD",
        value: formattedTotal,
        payment_type: payment.trim(),
        items: items,
      },
    });
  }
  // 参数：订单
  purchase(order) {
    // 运费
    let shipping = 0;
    let index = order.item.findIndex((e) => {
      return e.type == "SYS" && e.form_name == "運費";
    });
    if (index != -1) {
      shipping = String(order.item[index].price).replace(/[^0-9.]/g, "");
    }

    // 购物车商品
    let items = [];
    order.item.forEach((e) => {
      items.push({
        item_name: e.form_name,
        item_id: e.itemid,
        price: String(e.price).replace(/[^0-9.]/g, ""),
        quantity: e.num,
      });
    });
    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null }); // Clear the previous ecommerce object.
    dataLayer.push({
      event: "purchase",
      ecommerce: {
        transaction_id: order.order.order_num,
        currency: "TWD",
        value: order.total.replace(/[^0-9.]/g, ""),
        shipping,
        items,
      },
    });
  }
  // 参数：活动名称、关联商品
  view_promotion(name, item_list) {
    // 验证活动名称
    if (typeof name !== "string" || !name.trim()) {
      console.error("Invalid promotion name.");
      return;
    }

    // 验证商品列表
    if (!Array.isArray(item_list) || item_list.length === 0) {
      console.error("Invalid item list.");
      return;
    }

    let items = item_list
      .map((e, index) => {
        // 验证商品名称和ID
        if (
          typeof e.name !== "string" ||
          !e.name.trim() ||
          typeof e.id !== "string" ||
          !e.id.trim()
        ) {
          console.warn(`Invalid item at index ${index}.`);
          return null;
        }
        return {
          item_name: e.name.trim(),
          item_id: e.id.trim(),
        };
      })
      .filter((e) => e); // 过滤掉无效的商品

    if (items.length === 0) {
      console.error("No valid items for promotion.");
      return;
    }

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "view_promotion",
      ecommerce: {
        promotion_name: name.trim(),
        items,
      },
    });
  }
  // 参数：活动名称、点击商品

  select_promotion(name, item) {
    // 验证活动名称
    if (typeof name !== "string" || !name.trim()) {
      console.error("Invalid promotion name.");
      return;
    }

    // 验证商品名称和ID
    if (
      typeof item.name !== "string" ||
      !item.name.trim() ||
      typeof item.id !== "string" ||
      !item.id.trim()
    ) {
      console.error("Invalid item.");
      return;
    }

    window.dataLayer = window.dataLayer || [];
    dataLayer.push({ ecommerce: null });
    dataLayer.push({
      event: "select_promotion",
      ecommerce: {
        promotion_name: name.trim(),
        items: [
          {
            item_name: item.name.trim(),
            item_id: item.id.trim(),
          },
        ],
      },
    });
  }
}
